export enum OrgEnvironmentType {
  PRODUCTION = 'production',
  SANDBOX = 'sandbox',
  CUSTOM = 'custom',
  DEVELOPER = 'developer',
  SCRATCH = 'scratch',
}
